export default {
  setActiveStep(state, payload) {
    state.activeStep = payload;
  },
  setOrderApprovalInfo(state, payload) {
    state.orderApprovalInfo = payload;
  },
  setReadyToValidate(state, payload) {
    state.readyToValidate = payload;
  },
  setStepRequest(state, payload) {
    state.stepRequest = payload;
  },
  setCheckoutInfo(state, payload) {
    state.checkoutInfo = payload;
  },
  setInpostPoint(state, payload) {
    state.inpostPoint = payload;
  },
  setGLSPoint(state, payload) {
    state.glsPoint = payload;
  },
  setDpdPoint(state, payload) {
    state.dpdPoint = payload;
  },
  setSelectAllAgree(state, payload) {
    state.selectAllAgree = payload;
  },
  setPPPoint(state, payload) {
    state.ppPoint = payload;
  },
  setFormField(state, { field, value, isLogged }) {
    if (isLogged) {
      state.checkoutLoggedForm = { ...state.checkoutLoggedForm, [field]: value };
    } else {
      state.checkoutForm = { ...state.checkoutForm, [field]: value };
    }
  },
  setAddress(state, { field, value }) {
    state.checkoutForm.address = { ...state.checkoutForm.address, [field]: value };
  },
  setDeliveryAddress(state, { field, value }) {
    state.checkoutForm.deliveryAddress = { ...state.checkoutForm.deliveryAddress, [field]: value };
  },
  setNewDeliveryAddress(state, { field, value }) {
    state.checkoutLoggedForm.newDeliveryAddress = {
      ...state.checkoutLoggedForm.newDeliveryAddress,
      [field]: value,
    };
  },
  setOrderSummary(state, value) {
    state.orderSummary = value;
  },
  resetCheckout(state) {
    Object.assign(state, {
      activeStep: 3,
      readyToValidate: false,
      stepRequest: 0,
      checkoutInfo: null,
      dppPoint: null,
      inpostPoint: null,
      glsPoint: null,
      checkoutForm: {
        agreedCeneoTrustedOpinions: false,
        isIndividual: true,
        paymentMethod: '',
        companyName: '',
        taxId: '',
        firstName: '',
        lastName: '',
        userEmail: '',
        userNewsletterAgreement: false,
        userTermsOfUseAgreement: false,
        noteToOrder: '',
        createUserAccountAgreement: false,
        isDeliveryToAnotherAddress: false,
        eInvoiceAgreement: true,
        deliveryMethod: '',
        deliveryPointName: '',
        deliveryPointPni: '',
        address: {
          countryCode: '',
          streetWithNumber: '',
          city: '',
          zip: '',
          phone1: '',
        },
        deliveryAddress: {
          countryCode: '',
          streetWithNumber: '',
          city: '',
          zip: '',
          phone1: '',
          addressLine1: '',
        },
        insufficientStockDecision: '',
      },
      checkoutLoggedForm: {
        agreedCeneoTrustedOpinions: false,
        newDeliveryAddress: {
          countryCode: '',
          streetWithNumber: '',
          city: '',
          zip: '',
          phone1: '',
        },
        orderDeliveryDate: '',
        deliveryAddressId: null,
        costCenterId: null,
        paymentMethod: '',
        clientOrderNumber: '',
        isDeliveryAddressNew: false,
        eInvoiceAgreement: true,
        userNewsletterAgreement: false,
        noteToOrder: '',
        emailForPrepayment: '',
        deliveryMethod: '',
        deliveryPointName: '',
        deliveryPointPni: '',
        insufficientStockDecision: '',
        companyNameCompleted: '',
        companyStreetCompleted: '',
        companyZipCompleted: '',
        companyCityCompleted: '',
        userPhone: '',
      },
      orderSummary: {},
    });
  },
};
